import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BnContactCreateService {
  private readonly modalOpen$ = new Subject<boolean>();
  private readonly checkFormsValidity$ = new Subject<boolean>();
  private contactCreated$ = new Subject();
  private contactEdited$ = new Subject();
  private deleteContact$ = new Subject();
  private refreshList$ = new Subject();
  private isListLoading$ = new Subject();

  openModal() {
    this.modalOpen$.next(true);
  }

  closeModal() {
    this.modalOpen$.next(false);
  }

  getOpenModalSubscription() {
    return this.modalOpen$;
  }

  getCheckFormsValiditySubscription() {
    return this.checkFormsValidity$;
  }

  triggerFormsValidation() {
    this.checkFormsValidity$.next(true);
  }

  contactCreated(contact: any) {
    this.contactCreated$.next(contact);
  }

  getContactCreatedSubscription() {
    return this.contactCreated$;
  }

  contectEdited(contact: any) {
    this.contactEdited$.next(contact);
  }

  getContactEditedSubscription() {
    return this.contactEdited$;
  }

  deleteContact(contactId: string) {
    this.deleteContact$.next(contactId);
  }

  getContactDeleteSubscription() {
    return this.deleteContact$;
  }

  refreshList() {
    this.refreshList$.next();
  }

  getRefreshListSubscription() {
    return this.refreshList$;
  }

  getIsListLoading() {
    return this.isListLoading$;
  }

  setIsListLoading(value: boolean) {
    this.isListLoading$.next(value);
  }
}
